import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageFooterProps = ComponentProps<"div">

function ManageFooter(props: ManageFooterProps) {
  const { className, ...divProps } = props
  return <div className={cn("manage-footer", className)} {...divProps} />
}

export default ManageFooter
